// extracted by mini-css-extract-plugin
module.exports = {"link-blue":"#325bbd","editor":"Editor-module__editor___1kU-V"};